import classNames from "classnames";
import { TriangleIcon } from "../../../icons";
import { Button } from "../Button/Button";
import css from "./Tree.module.scss";

interface TreeItemCaretProps {
    isExpanded: boolean;
    onToggle: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
}

export const TreeItemCaret = ({
    isExpanded,
    onToggle,
    className,
}: TreeItemCaretProps) => (
    <Button
        variant="tertiary"
        icon
        size="sm"
        onClick={onToggle}
        className={className}
    >
        <TriangleIcon
            className={classNames(css.caret, {
                [css.expanded]: isExpanded,
            })}
        />
    </Button>
);
